// extracted by mini-css-extract-plugin
export default {"lineaNormal":"Linea_lineaNormal__TEW6E","lineaDoblePauta":"Linea_lineaDoblePauta__wdRxf"};